module.exports = __webpack_public_path__ + "static/rumia-willbud-tablet-00ec97234a98e1d95f1a0f45f33f3fca.jpg";